import { render, staticRenderFns } from "./TrademarkProvisionalStatus.vue?vue&type=template&id=2d7d787e&"
import script from "./TrademarkProvisionalStatus.vue?vue&type=script&lang=js&"
export * from "./TrademarkProvisionalStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports